import { Component } from '@verndale/core';
import * as focusTrap from 'focus-trap';
import clickOutside from 'click-outside';
import { KEYS, KEYS_DIRECTION } from '../constants';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $el: this.el,
      $hamburger: this.el._$('.header__hamburger'),
      $searchPanelTrigger: this.el._$('.header__search-panel-trigger'),
      $panelOverlay: this.el._$('.header__panel-outer'),
      $panel: this.el._$('.header__panel'),
      $closePanelButton: this.el._$('.header__close-panel-trigger'),
      $inMenuPrimaryNavButton: this.el._$$('.in-menu-primary-nav__trigger'),
      $backButton: this.el._$$('.header-menu__back'),
      $inMenuClosePanelButton: this.el._$('.header__panel-close-trigger'),
      $inMenuNav: this.el._$('.header__panel'),
      $primaryNavLinks: this.el._$$('.primary-nav__link'),
      $myAccountTrigger: this.el._$('.header-panel__my-account-trigger'),
      $myAccountTriggerWrapper: this.el._$(
        '.header-panel__my-account-trigger-wrapper'
      ),
      $myAccountPanel: this.el._$('.my-account'),
      $linkAndFeatured: this.el._$$('.link-and-featured'),
      $emailForm: this.el._$('.my-account__email-form'),
      $emailField: this.el._$('[type="email"]'),
      $hiddenEmailField: this.el._$('.my-account__hidden-email'),
      $emailText: this.el._$('.my-account__email-text'),
      $emailChange: this.el._$('.my-account__email-change'),
      $organizationSubmit: this.el._$(
        '.my-account__organisation-form [type=submit]'
      ),
      $dropdownMenuTriggers: this.el._$$('.header-dropdown-menu__trigger'),
      $dropownMyAccountTrigger: this.el._$(
        '.header-dropdown-menu__my-account-trigger'
      ),
      $designElements: this.el._$$('.header-panel__design-element-wrapper'),
      $organizations: () => this.el._$('.my-account__organizations select')
    };
    this.baseHeaderActivatedClass = 'header--base-search-activated';
    this.bodyPanelOpenedClass = 'header-panel-opened';
    this.menuPanelOpenedClass = 'header--panel-opened';
    this.inMenuPanelOpenedClass = 'header--in-menu-panel-opened';
    this.currentDesignElementClass =
      'header-panel__design-element-wrapper--current';
    this.closePanelevent = new CustomEvent('close');

    this.initiateFocusTrap();
  }

  addListeners() {
    this.dom.$hamburger._on('click', this.openHeaderPanel.bind(this));
    this.dom.$panelOverlay._on('click', this.onPanelOverlayClick.bind(this));
    this.dom.$searchPanelTrigger._on(
      'click',
      this.onSearchPanelTriggerClick.bind(this)
    );
    this.dom.$closePanelButton._on(
      'click',
      this.onClosePanelButtonClick.bind(this)
    );
    this.dom.$inMenuClosePanelButton._on(
      'click',
      this.closeHeaerPanel.bind(this)
    );
    this.dom.$inMenuPrimaryNavButton._on(
      'click',
      this.onInMenuButtonClick.bind(this)
    );
    this.dom.$backButton._on('click', this.onBackButtonClick.bind(this));
    this.dom.$primaryNavLinks._on(
      'mousedown',
      this.onPrimaryNavLinkMouseDown.bind(this)
    );
    this.dom.$primaryNavLinks._on(
      'mouseup',
      this.onPrimaryNavMouseUp.bind(this)
    );
    this.dom.$primaryNavLinks._on(
      'keydown',
      this.onPrimaryNavKeyDown.bind(this)
    );
    this.dom.$primaryNavLinks._on('keyup', this.onPrimaryNavKeyUp.bind(this));
    this.dom.$myAccountTrigger._on(
      'click',
      this.onMyAccountTriggerClick.bind(this)
    );
    this.dom.$linkAndFeatured._on('tabchange', this.updateCtaText.bind(this));
    this.dom.$emailForm._on(
      'successfullysubmitted',
      this.handleEmailFormSubmit.bind(this)
    );
    this.dom.$dropdownMenuTriggers._on(
      'click',
      this.handleDropdownMenuTriggerClick.bind(this)
    );
    this.dom.$dropownMyAccountTrigger?._on?.(
      'click',
      this.handleDropdownMyAccountTriggerClick.bind(this)
    );
    this.dom.$emailChange._on('click', this.onEmailChange.bind(this));
    this.dom.$panel._on('tabchange', this.updateDesignElement.bind(this));
    this.el._on('register', this.handleRegister.bind(this));
    document._on('mousedown', this.onClickOutsidePanel.bind(this));

    this.autoClickMyAccountTriggerIfNeeded();
  }

  onInMenuButtonClick() {
    this.dom.$el.classList.add(this.inMenuPanelOpenedClass);
    const event = new CustomEvent('reset');
    this.dom.$myAccountTriggerWrapper.dispatchEvent(event);
    this.dom.$myAccountPanel.setAttribute('aria-hidden', 'true');
  }

  onPanelOverlayClick(e) {
    if (e.target.classList.contains('header__panel-outer')) {
      this.closeHeaerPanel();
    }
  }

  onClosePanelButtonClick() {
    this.closeHeaerPanel();
    this.dom.$el.classList.remove(this.inMenuPanelOpenedClass);
  }

  onBackButtonClick() {
    this.dom.$el.classList.remove(this.inMenuPanelOpenedClass);
  }

  onPrimaryNavLinkMouseDown(e) {
    this.openHeaderPanel();
    this.dom.$el.classList.remove(this.baseHeaderActivatedClass);
    this.activateInMenuPanel(e.target.dataset.id);
    this.panelFocusTrap.activate();
  }

  onPrimaryNavMouseUp() {
    this.panelFocusTrap.activate();
  }

  onPrimaryNavKeyDown(e) {
    switch (e.keyCode) {
    case KEYS.END:
      this.focusPrimaryNavOnKeyPress(
        this.dom.$primaryNavLinks[this.dom.$primaryNavLinks.length - 1]
      );
      break;
    case KEYS.HOME:
      e.preventDefault();
      this.focusPrimaryNavOnKeyPress(this.don.$primaryNavLinks[0]);
      break;
    case KEYS.DOWN:
    case KEYS.ENTER:
      e.preventDefault();
      this.openHeaderPanel();
      this.activateInMenuPanel(e.target.dataset.id);
      this.panelFocusTrap.activate();
      break;
    }
  }

  onPrimaryNavKeyUp(e) {
    switch (e.keyCode) {
    case KEYS.LEFT:
    case KEYS.RIGHT:
      this.focusPrimaryNavOnKeyPress(e);
      break;
    case KEYS.UP:
    case KEYS.DOWN:
    case KEYS.ENTER:
      this.focusPrimaryNavOnKeyPress(e);
      break;
    }
  }

  onMyAccountTriggerClick(e) {
    this.dom.$el.classList.add(this.inMenuPanelOpenedClass);
    const event = new CustomEvent('reset');
    this.dom.$panel.dispatchEvent(event);
    this.updateDesignElement({ detail: { id: 'account' } });
  }

  onClickOutsidePanel(e) {
    if (e.pageX <= document.documentElement.clientWidth) return;
    if (e.target.classList.contains('header__hamburger')) return;
    if (e.target.classList.contains('header__panel')) return;
    if (e.target.classList.contains('header-search__reset')) return;
    if (e.target.closest('.header__panel')) return;
    if (e.target.closest('.primary-nav')) return;
    this.closeHeaerPanel();
  }

  onPauseHeaderPanelFocusTrap() {
    this.panelFocusTrap.pause();
  }

  onContinueHeaderPanelFocusTrap() {
    this.panelFocusTrap.unpause();
  }

  onSearchPanelTriggerClick() {
    this.openHeaderPanel();
    this.dom.$el.classList.add(this.baseHeaderActivatedClass);
    this.panelFocusTrap.activate();
  }

  onEmailChange() {
    this.resetForm();
  }

  initiateFocusTrap() {
    this.panelFocusTrap = focusTrap.createFocusTrap(this.dom.$panel, {
      onDeactivate: this.closeHeaerPanel.bind(this),
      allowOutsideClick: true,
      initialFocus: () => {
        if (this.dom.$el.classList.contains(this.baseHeaderActivatedClass)) {
          return this.dom.$el._$('.header-search__input');
        }
        return (
          this.dom.$el._$(
            '.header-menu:not([aria-hidden]) .header-menu__link'
          ) ||
          this.dom.$el._$(
            '.header-menu:not([aria-hidden]) .my-account__callout-cta'
          ) ||
          this.dom.$el._$('.header__panel-close-trigger')
        );
      }
    });
  }

  focusPrimaryNavOnKeyPress(e) {
    if (!KEYS_DIRECTION[e.keyCode]) return;
    if (typeof e.target.dataset.index === 'undefined') return;
    const index = parseInt(e.target.dataset.index, 10);

    if (this.dom.$primaryNavLinks[index + KEYS_DIRECTION[e.keyCode]]) {
      this.focusPrimaryNavItem(
        this.dom.$primaryNavLinks[index + KEYS_DIRECTION[e.keyCode]]
      );
      return;
    }

    if (e.keyCode === KEYS.left) {
      this.focusPrimaryNavItem(
        this.dom.$primaryNavLinks[this.dom.$primaryNavLinks.length - 1]
      );
    } else if (e.keyCode === KEYS.right) {
      this.focusPrimaryNavItem(this.dom.$primaryNavLinks[0]);
    }
  }

  focusPrimaryNavItem(item) {
    this.blurPrimaryNavItems();
    item.removeAttribute('tabindex');

    item.focus();
  }

  blurPrimaryNavItems() {
    this.dom.$primaryNavLinks.forEach(link => {
      link.setAttribute('tabindex', '-1');
    });
  }

  openHeaderPanel() {
    document.body.classList.add(this.bodyPanelOpenedClass);
    this.dom.$el.classList.add(this.menuPanelOpenedClass);
  }

  closeHeaerPanel() {
    this.panelFocusTrap.deactivate();
    document.body.classList.remove(this.bodyPanelOpenedClass);
    this.dom.$el.classList.remove(this.menuPanelOpenedClass);
    this.unbindPanelOutsideClick?.();
    this.dom.$el.dispatchEvent(this.closePanelevent);
    const event = new CustomEvent('reset');
    this.dom.$myAccountTriggerWrapper.dispatchEvent(event);
  }

  activateInMenuPanel(id) {
    const event = new CustomEvent('activatetab', { detail: { id } });
    this.dom.$inMenuNav.dispatchEvent(event);
  }

  updateCtaText(e) {
    const hiddenClass = 'link-and-featured-link-items__cta--hidden';
    const trigger = document.getElementById(e.detail.id);
    const panel = document.getElementById(
      trigger.getAttribute('aria-controls')
    );
    const identifier = panel.dataset.identifier;
    const originalBtn = panel._$('.link-and-featured-link-items__cta');
    const clone = _$(`.link-and-featured[data-identifier=${identifier}]`)
      ._$('.link-and-featured__tabs-cta-wrapper')
      ._$('.link-and-featured-link-items__cta');

    if (!originalBtn) {
      clone.classList.add(hiddenClass);
      return;
    }

    const text = originalBtn.textContent;
    clone.classList.remove(hiddenClass);
    clone.textContent = text;
    clone.href = originalBtn.href;
  }

  handleEmailFormSubmit(e) {
    const orgs = this.dom.$organizations();
    const isSingle = e.detail?.Organizations.length === 1;
    const placeholderValue = orgs.getAttribute('placeholder');
    const placeholder = `<option value="">${
      placeholderValue ? placeholderValue : ''
    }</option>`;
    const renderOption = org =>
      `<option value=${org.value}>${org.label}</option>`;

    this.dom.$emailText.textContent = this.dom.$emailField.value;
    orgs.innerHTML = `
      ${isSingle ? '' : placeholder}
      ${e.detail?.Organizations?.map?.(renderOption).join()}
    `;

    this.dom.$hiddenEmailField.value = this.dom.$emailField.value;

    if (isSingle) {
      orgs.disabled = true;
      orgs.closest('.form-select').classList.add('form-select--disabled');
      orgs.value = e.detail.Organizations[0].value;
      this.dom.$organizationSubmit.disabled = false;
      this.dom.$organizationSubmit.classList.remove('btn--disabled');
    } else {
      orgs.disabled = false;
      orgs.closest('.form-select').classList.remove('form-select--disabled');
      this.dom.$organizationSubmit.disabled = true;
      this.dom.$organizationSubmit.classList.add('btn--disabled');
    }

    const event = new CustomEvent('update');
    orgs.dispatchEvent(event);
  }

  handleDropdownMenuTriggerClick(e) {
    const $parent = e.currentTarget.parentNode;
    $parent.classList.toggle('header-dropdown-menu--expanded');
    if ($parent.classList.contains('header-dropdown-menu--expanded')) {
      clickOutside($parent, () => {
        $parent.classList.remove('header-dropdown-menu--expanded');
      });
    }
  }

  handleDropdownMyAccountTriggerClick(e) {
    this.onPrimaryNavLinkMouseDown(e);
    this.updateDesignElement({ detail: { id: 'account' } });
  }

  handleRegister() {
    this.openHeaderPanel();
    this.activateInMenuPanel('my-account-tab');
    this.dom.$el.classList.add(this.inMenuPanelOpenedClass);
    this.panelFocusTrap.activate();
  }

  updateDesignElement(e) {
    const { id } = e.detail;
    const current = this.dom.$designElements.find(
      el => el.dataset.navId === id
    );
    this.dom.$designElements.forEach(el =>
      el.classList.remove(this.currentDesignElementClass)
    );
    current?.classList?.add?.(this.currentDesignElementClass);
  }

  resetForm() {
    this.dom.$emailForm.reset();
    this.dom.$emailForm.classList.remove('form--success');
    this.dom.$emailField.focus();
  }

  autoClickMyAccountTriggerIfNeeded() {
    const params = new URL(document.location).searchParams;

    if (typeof (params.get('register')) === 'string')
      this.dom.$dropownMyAccountTrigger?.click?.();
  }
}

export default Module;
